export const QUALIFICATIONS = [
  { qualificationsName: 'LATAM' },
  { qualificationsName: 'NA' },
  { qualificationsName: 'EUROPA' },
  { qualificationsName: 'ÁSIA' },
  { qualificationsName: 'OCEANIA' }
]

export const CONTACT_INITIAL_STATE = { email: '', name: '', phone: '' }

export const INITIAL_FILE_STATE = { src: '', filename: '' }

export const CERTIFICATE_INITIAL_STATE = {
  name: '',
  acronym: '',
  number: '',
  dtEmitted: null,
  dtExpiry: null,
  status: '',
  emails: '',
  alert: '',
  idCertifier: '',
  nameCertifier: '',
  file: null,
  logo: null
}

export const INITIAL_STATE = {
  address: '',
  cep: '',
  city: '',
  cnpj: '',
  contacts: [{ ...CONTACT_INITIAL_STATE }],
  country: 'bra',
  fancyName: '',
  groups: [],
  ie: '',
  inspectionNum: '',
  inspectionType: '',
  lat: null,
  lng: null,
  name: '',
  manager: {
    bio: '',
    doc: '',
    name: '',
    photo: null
  },
  photos: [],
  qualifications: [],
  certificates: [],
  sifPhoto: null,
  state: '',
  status: true,
  technician: {
    bio: '',
    doc: '',
    name: '',
    photo: null
  },
  documentType: 'nacional'
}

export const ERRORS_INITIAL_STATE = {
  address: '',
  cep: '',
  city: '',
  cnpj: '',
  contacts: [{ ...CONTACT_INITIAL_STATE }],
  country: '',
  fancyName: '',
  ie: '',
  inspectionNum: '',
  inspectionType: '',
  lat: '',
  lng: '',
  name: '',
  manager: {
    bio: '',
    doc: '',
    name: ''
  },
  qualifications: '',
  certificates: [],
  sifPhoto: null,
  state: '',
  status: null,
  technician: {
    bio: '',
    doc: '',
    name: ''
  },
  documentType: ''
}

export const GROUP_FILTER_INITIAL_STATE = {
  name: '',
  fancyName: '',
  cnpj: ''
}
